﻿import React, { useContext } from 'react';
import Context, { context_type } from '@Util/Context';
import { NavLink } from "react-router-dom";
import { Navigation_Item_Props } from '@Util/Types';

export default function Navigation_Item(props: Navigation_Item_Props): JSX.Element {
    const { set_sidebar_visible, logged_in_user }: context_type = useContext(Context);

    if (props.adminRequired && !logged_in_user?.isAdmin) {
        return null;
    }

    return (
        <li className="Side_Navigation_List_Item">
            <NavLink
                to={props.to}
                end
                className={({ isActive }) => isActive ? "Active" : ""}
                title={props.name}
                onClick={() => set_sidebar_visible(false)}
            >
                { props.icon }
                { props.name }
            </NavLink>
        </li>
    );
}